// IND-058: al cerrar sesión (o entrar otro usuario en la misma pestaña) no
// queda nada del usuario anterior en el navegador.
import queryClient from './queryClient';

// Guardado en el navegador que es del usuario o de su empresa: se borra.
// PRC-026: «proa-pricing-account-state-v1» es el estado recordado de la cuenta de Pricing.
const USER_LOCAL_KEYS = ['industrial-cost-import-center-learned-importers-v1', 'proa-pricing-account-state-v1'];
const USER_LOCAL_PREFIXES = ['poker-study:'];
const USER_SESSION_KEYS = ['proa-industrial-operator-selected-report-id'];
// Se conserva a propósito:
// - «ic-recount-queue-<usuario>-<hoja>» y «ic-recount-row-<usuario>-<hoja>»:
//   valores contados en la tablet aún sin enviar. Van por usuario (nadie más
//   los ve) y borrarlos perdería lo contado.
// - «ic-recount-device» y «proa-industrial-operator-touch-mode»: del aparato.

export function clearUserBrowserData(): void {
  queryClient.clear();
  try {
    const local = window.localStorage;
    const keys: string[] = [];
    for (let index = 0; index < local.length; index += 1) {
      const key = local.key(index);
      if (key && (USER_LOCAL_KEYS.includes(key) || USER_LOCAL_PREFIXES.some((prefix) => key.startsWith(prefix)))) {
        keys.push(key);
      }
    }
    keys.forEach((key) => local.removeItem(key));
    USER_SESSION_KEYS.forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    // Sin acceso al almacenamiento del navegador no hay nada que borrar.
  }
}
